<template>
  <div class="app-wrapper">
    <Header v-if="!$route.meta.hideHeaderFooter" />

    <main class="app-content">
      <router-view />
    </main>

    <Appfooter v-if="!$route.meta.hideHeaderFooter" />
    <LeitnerAddWordFab />
    <WelcomeOnboardingDialog />
  </div>
</template>

<script lang="ts">
import Header from './components/Sections/Header.vue'
import Appfooter from './components/Sections/Appfooter.vue'
import LeitnerAddWordFab from './components/LeitnerAddWordFab.vue'
import WelcomeOnboardingDialog from './components/WelcomeOnboardingDialog.vue'
import { startPushNotifications } from './composables/usePushNotifications'

export default {
  name: "App",

  components: {
    Header,
    Appfooter,
    LeitnerAddWordFab,
    WelcomeOnboardingDialog,
  },
  setup() {
    startPushNotifications();
  },
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

</style>
